export enum StripeAccountStatus {
    Valid = 'valid',
    Invalid = 'invalid',
    PendingDetails = 'pending-details',
}

/**
 * Model to hold Stripe account data
 */
export class StripeAccount {
    public static NAME: string = 'stripeAccount';
    public static TYPE_CUSTOM: string = 'custom';
    public static TYPE_EXPRESS: string = 'express';

    public id: string;
    public externalAccountName: string;
    public businessName: string;
    public email: string;
    public type: string;
    public status: string;
    public statusReason: string;

    constructor(id?: string) {
        this.id = id;
    }

    public clone(): StripeAccount {
        const clone: StripeAccount = new StripeAccount();
        clone.id = this.id;
        clone.externalAccountName = this.externalAccountName;
        clone.businessName = this.businessName;
        clone.email = this.email;
        clone.type = this.type;
        clone.status = this.status;
        clone.statusReason = this.statusReason;
        return clone;
    }

    public isCustom(): boolean {
        return this.type === StripeAccount.TYPE_CUSTOM;
    }

    public isExpress(): boolean {
        return this.type === StripeAccount.TYPE_EXPRESS;
    }

    public isPendingDetails(): boolean {
        return this.status === StripeAccountStatus.PendingDetails;
    }

    public isValid(): boolean {
        return this.status === StripeAccountStatus.Valid;
    }

    public formatStatus(): string {
        switch (this.status) {
            case StripeAccountStatus.Valid:
                return 'Valid';
            case StripeAccountStatus.Invalid:
                return 'Invalid';
            case StripeAccountStatus.PendingDetails:
                return 'Pending Details';
            default:
                return 'Unknown';
        }
    }

    public deserialize(json: any): StripeAccount {
        const data: any = json.data || json;
        const attrs: any = data.attributes;

        this.id = data.id;
        this.externalAccountName = attrs.externalAccountName || data.id;
        this.businessName = attrs.businessName;
        this.email = attrs.email;
        this.type = attrs.type;
        this.status = attrs.status;
        this.statusReason = attrs.statusReason;

        return this;
    }
}
